import { z } from 'zod';

export const arcCoreSchema = z.object({
  id: z.string().optional(),
  name: z.string().min(1, "Name is required"),
  description: z.string().optional(),
  type: z.enum(['plot', 'character']),
  characterId: z.string().optional(),
  narrativeStatus: z.enum(['notWritten', 'partial', 'complete']).optional(),
  order: z.number().optional(),
  color: z.string().optional(),
});

export const arcEventSchema = z.object({
  eventId: z.string(),
  name: z.string(),
  summary: z.string().optional(),
  position: z.object({
    x: z.number(),
    y: z.number(),
  }),
});

export const arcEdgeSchema = z.object({
  id: z.string(),
  sourceEventId: z.string(),
  targetEventId: z.string(),
  label: z.string().optional(),
});

export const arcDetailsSchema = z.object({
  events: z.array(arcEventSchema),
  edges: z.array(arcEdgeSchema),
});

export const arcFormSchema = arcCoreSchema;
